import React, { useState, useContext, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useForm, Controller } from "react-hook-form";
import { UserInputData } from '../WarrantyFrame';
import CheckListTable from '../../../checkListTable'

export default function InsForm12MT(props) {
    const { currentState, setCurrentState } = useContext(UserInputData);
    const { control, getValues, setValue, } = useForm({
        defaultValues: { ...currentState, ...currentState },
        mode: 'onChange'
    });
    const [valueOnChange, setValueOnChange] = useState(false)
    const [isComplete, setIsComplete] = useState(0)
    const [resetValues, setResetValues] = useState(false)

    useEffect(() => {
        let upDateArray = JSON.parse(JSON.stringify(currentState));
        upDateArray = getValues();
        setCurrentState(upDateArray)
    }, [valueOnChange])


    useEffect(() => {
        //親フォームで取得した点検項目の値をセット
        if (currentState) {
            Object.entries(currentState).forEach(([key, value]) => {
                setValue(key, value)
            })
            setIsComplete(isComplete + 1)
        }
    }, [props.isEffectDone])

    useEffect(() => {
        //セットした値を元にチェックボックスへ反映
        if (isComplete === 2) {
            setResetValues(!resetValues)
        }
    }, [isComplete])


    const handleCheckListValues = (returnValue) => {
        if (!Object.keys(returnValue)[0]) return;
        for (let i = 0; i < Object.keys(returnValue).length; i++) {
            setValue(Object.keys(returnValue)[i], String(Object.values(returnValue)[i]))
        }
        setValueOnChange(!valueOnChange)
    };
    return (
        <React.Fragment>
            <Typography sx={{ fontSize: '2rem', }}>3　定期点検項目</Typography>
            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>外部建具</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>1.玄関ドア</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="genkan"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'genkanKaihei',
                                        label: '開閉状況',
                                        value: parseInt(getValues("genkanKaihei"))
                                    }, {
                                        id: 'genkanPakkin',
                                        label: 'パッキン、金具',
                                        value: parseInt(getValues("genkanPakkin"))
                                    }, {
                                        id: 'genkanKyuyu',
                                        label: '給油',
                                        value: parseInt(getValues("genkanKyuyu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>2.バルコニードア</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="barukoni"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'barukoniKaihei',
                                        label: '開閉状況',
                                        value: parseInt(getValues("barukoniKaihei"))
                                    }, {
                                        id: 'barukoniPakkin',
                                        label: 'パッキン、金具',
                                        value: parseInt(getValues("barukoniPakkin"))
                                    }, {
                                        id: 'barukoniKyuyu',
                                        label: '給油',
                                        value: parseInt(getValues("barukoniKyuyu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>3.スライディングドア</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="suraidhing"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'suraidhingKaihei',
                                        label: '開閉状況',
                                        value: parseInt(getValues("suraidhingKaihei"))
                                    }, {
                                        id: 'suraidhingPakkin',
                                        label: 'パッキン、金具',
                                        value: parseInt(getValues("suraidhingPakkin"))
                                    }, {
                                        id: 'suraidhinguKyuyu',
                                        label: '給油',
                                        value: parseInt(getValues("suraidhinguKyuyu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>4.窓</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="window"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'windowKaihei',
                                        label: '開閉状況',
                                        value: parseInt(getValues("windowKaihei"))
                                    }, {
                                        id: 'windowPakkin',
                                        label: 'パッキン、金具',
                                        value: parseInt(getValues("windowPakkin"))
                                    }, {
                                        id: 'windowKyuyu',
                                        label: '給油',
                                        value: parseInt(getValues("windowKyuyu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>5.共通 ; 開口部防水</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="common"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'commonSanho',
                                        label: '三方シーリング',
                                        value: parseInt(getValues("commonSanho"))
                                    }, {
                                        id: 'commonMIzukiri',
                                        label: '水切差込部',
                                        value: parseInt(getValues("commonMIzukiri"))
                                    }, {
                                        id: 'commonRyotan',
                                        label: '両端シーリング',
                                        value: parseInt(getValues("commonRyotan"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>内部建具</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>1.内部ドア</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="naibu"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'naibuKaihei',
                                        label: '開閉状況',
                                        value: parseInt(getValues("naibuKaihei"))
                                    }, {
                                        id: 'naibuPakkin',
                                        label: 'パッキン、金具',
                                        value: parseInt(getValues("naibuPakkin"))
                                    }, {
                                        id: 'naibuKyuyu',
                                        label: '給油',
                                        value: parseInt(getValues("naibuKyuyu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>水回り</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>1.浴室</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="yokushitu"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'yokushituKigu',
                                            label: '各種器具',
                                            value: parseInt(getValues("yokushituKigu"))
                                        }, {
                                            id: 'yokushituShiring',
                                            label: 'シーリング',
                                            value: parseInt(getValues("yokushituShiring"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>2.キッチン</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="kittin"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'kittinKigu',
                                            label: '各種器具',
                                            value: parseInt(getValues("kittinKigu"))
                                        }, {
                                            id: 'kittinSonota',
                                            label: 'その他',
                                            value: parseInt(getValues("kittinSonota"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>3.洗面台</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="senmen"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'senmenKigu',
                                            label: '各種器具',
                                            value: parseInt(getValues("senmenKigu"))
                                        }, {
                                            id: 'senmenSonota',
                                            label: 'その他',
                                            value: parseInt(getValues("senmenSonota"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>4.洗濯機置場</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="sentaku"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'sentakuKigu',
                                            label: '各種器具',
                                            value: parseInt(getValues("sentakuKigu"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>設備</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>1.24時間換気</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="kanki"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'kankiFilter',
                                            label: 'フィルター',
                                            value: parseInt(getValues("kankiFilter"))
                                        }, {
                                            id: 'kankiNetukoukan',
                                            label: '熱交換素子',
                                            value: parseInt(getValues("kankiNetukoukan"))
                                        }, {
                                            id: 'kankiKanrei',
                                            label: '寒冷地仕様',
                                            value: parseInt(getValues("kankiKanrei"))
                                        },]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>2.局所換気</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="kyokusyo"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'kyokusyoFilter',
                                            label: 'フィルター',
                                            value: parseInt(getValues("kyokusyoFilter"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>3.冷暖房設備</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="reidanbo"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'reidanboEakon',
                                            label: 'エアコンの状況',
                                            value: parseInt(getValues("reidanboEakon"))
                                        }, {
                                            id: 'reidanboKanrei',
                                            label: '寒冷地仕様',
                                            value: parseInt(getValues("reidanboKanrei"))
                                        }, {
                                            id: 'reidanboSuraimu',
                                            label: 'スライム対策',
                                            value: parseInt(getValues("reidanboSuraimu"))
                                        },]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>特殊</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>1.木製バルコニー</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="Tokusyu"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'mokuseiOriginal',
                                            label: 'オリジナル木質強化剤塗布： 柱・梁の加工部、小口',
                                            value: parseInt(getValues("mokuseiOriginal"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </React.Fragment>
    )
}
